import { render, staticRenderFns } from "./QQ.vue?vue&type=template&id=7a8e3647"
import script from "./QQ.vue?vue&type=script&lang=ts"
export * from "./QQ.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "667e7f90"
  
)

export default component.exports